import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import once from 'lodash.once';

dayjs.extend(isBetween);

export const showChristmasOffer = once(() => {
	const now = dayjs();
	const currentYear = now.year();
	const startMonth = process.env.NEXT_PUBLIC_TARGET_ENV === 'prod' ? 11 : 10;
	// the DST changes in Czechia the last october's weekend, the production offer starts in november, thus this counts
	// with GTM+1 only.
	const timeAndZone = `T00:00:00+01:00`;
	const start = dayjs(`${currentYear}-${startMonth}-01${timeAndZone}`);
	const end = dayjs(`${currentYear}-12-21${timeAndZone}`);
	return now.isBetween(start, end, 'day', '[]');
});
